import React, { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Button from '../Button';
import { getCardsForProduct, getCountProducts } from '../../utils/Gifts/basket';
import {
  isCorporateGift,
  isCustomPrice,
  isFreeProduct,
  isSantaLetterProduct,
} from '../../utils/Gifts/products';
import { SiteSettingsContext } from '../../utils/context';
import BasketItem from './BasketItem/BasketItem';
import Link from '../Link';
import FreeProductsOfferings from '../FreeProductsOfferings';
import BestSellerGifts from '../BestSellerGifts';
import BasketSummary from './BasketSummary/BasketSummary';
import CustomDonationWidget from '../CustomDonationWidget';
import { pushEcommerceCheckoutStep as gtmPushEcommerceCheckoutStep } from '../../utils/Gifts/gtm';
import SantaLetterBasketItem from './SantaLetterBasketItem';

import styles from './index.module.scss';

const BasketPage = () => {
  const basketProducts = [];
  const products = useSelector((state) => state.basket.products);
  const basketType = useSelector((state) => state.basket.type);

  products.forEach((product) => {
    if (
      (!isCustomPrice(product.data) || basketType === 'corporate') &&
      !isSantaLetterProduct(product.data)
    ) {
      basketProducts.push(<BasketItem key={product.id} product={product} />);
    }
    if (isSantaLetterProduct(product.data)) {
      const santaLetterCards = getCardsForProduct(product, 'santaLetters');
      santaLetterCards.forEach((item, index) =>
        basketProducts.push(
          <SantaLetterBasketItem key={`${product.id}-${index}`} item={item} cardIndex={index} />,
        ),
      );
    }
  });
  const count = getCountProducts(products);

  useEffect(() => {
    if (products.length) {
      gtmPushEcommerceCheckoutStep({ step: 1, option: basketType }, products);
    }
  }, [products]);

  const settings = useContext(SiteSettingsContext);
  const catalogUrl = settings.catalogUrl.url;

  return (
    <div className={styles['basket-page']}>
      <div className="container">
        <div className="basket-nav">
          <Link href={catalogUrl}>
            <Button withBackArrow type={'secondary'} isOutlined size={'small'}>
              Continue shopping
            </Button>
          </Link>
        </div>
        {count > 0 ? (
          <h1 className="space-top">
            {`Shopping Basket (${count} ${count === 1 ? 'item' : 'items'})`}
          </h1>
        ) : (
          <h1 className="space-top">Your basket is empty</h1>
        )}

        <div>
          <FreeProductsOfferings variant="basket-page" />
          <div className={`space-top ${styles['basket-page__products']}`}>
            {basketProducts}

            {(basketType === 'gift' || !basketType) && (
              <CustomDonationWidget mode={basketProducts.length > 0 ? 'basket' : 'empty-basket'} />
            )}
          </div>
        </div>
        <aside>
          <BasketSummary />

          <div className={styles['basket-page__actions']}>
            {products.some(
              (item) =>
                !isFreeProduct(item.data) &&
                !isCustomPrice(item.data) &&
                !isSantaLetterProduct(item.data) &&
                !isCorporateGift(item.data),
            ) ? (
              <Link href="/cards">
                <Button
                  withArrow
                  isMobileBlock
                  type={'secondary'}
                  data-component="continue-checkout-button"
                >
                  Choose delivery method
                </Button>
              </Link>
            ) : (
              <Link href="/checkout">
                <Button
                  withArrow
                  isMobileBlock
                  type={'secondary'}
                  isDisabled={count === 0}
                  data-component="continue-checkout-button"
                >
                  Continue to checkout
                </Button>
              </Link>
            )}
          </div>
          {basketType !== 'corporate' && <BestSellerGifts />}
        </aside>
      </div>
    </div>
  );
};

export default BasketPage;
